import {Map} from 'immutable'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Chip from '@mui/material/Chip'

import {TextGutterMedium, Text} from '../../../../../dashboard/src/components/blocks/Texts'
import {ContentBox} from '../../../../../dashboard/src/components/blocks/ContentBoxes'
import {Button} from '../../../../../dashboard/src/components/blocks/Buttons'
import {monthDayYear, dateToFromNowDaily} from '../../../../../lib/dateTools'

const TfaEnrollmentDetails = props => (
  <ContentBox className='tfa-enrollments-details flex-container'>
    <ContentBox className={classnames('icon-container', {inactive: props.tfaEnrollment.isEmpty()})}>
      {props.icon}
    </ContentBox>
    <ContentBox className='enrollments-container'>
      <Text className='enrollments-header flex-container'>
        <h3>{props.name}</h3>
        {props.primary && <Chip className='badge' label='Primary' size='small' />}
      </Text>
      <TextGutterMedium className='instruction'>{props.instruction}</TextGutterMedium>
      {
        !props.tfaEnrollment.isEmpty() && (
          <div className='enrollment-dates flex-container'>
            <div>
              Set up: {monthDayYear(props.tfaEnrollment.get('enabled-at'), 'MMMM D, YYYY')}
            </div>
            {props.tfaEnrollment.get('last-used-at') &&
            <div>
              Last used: {dateToFromNowDaily(props.tfaEnrollment.get('last-used-at'))}
            </div>}
          </div>
        )
      }
      <Button onClick={props.primaryAction} processing={props.loading}>{props.buttonText}</Button>
    </ContentBox>
  </ContentBox>
)

TfaEnrollmentDetails.propTypes = {
  buttonText: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.element.isRequired,
  tfaEnrollment: PropTypes.instanceOf(Map),
  name: PropTypes.string.isRequired,
  instruction: PropTypes.string,
  primaryAction: PropTypes.func
}

export default TfaEnrollmentDetails
